<template>
	<div class="navigation-dashboard">
		<router-link v-if="selectedAccount" :to="{ name: 'Dashboard', params: { user_uid: selectedAccount } }" class="nav-link">
			<svgicon name="dashboard" :fill="false"></svgicon>
			<span>{{ $t('base.general.dashboard') }}</span>
		</router-link>
	</div>
</template>

<script>
export default {
	computed: {
		selectedAccount () {
			return this.$store.state.user.selectedAccount
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/navigation/NavigationDashboard.vue